export let ok = (value) => ({
    type: "output",
    value
});
export const is_ok = (res) => res.type === "output";
export function isInterp(c) {
    return c === "interpreter";
}
export function isPerm(c) {
    return c === "permissions";
}
//# sourceMappingURL=lib.js.map